import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import apiPath from './apiPath'

const api = {
  CreateMenuPrice(payload) {
    return requestPost(apiPath.MENU_PRICE.path, payload)
  },

  GetOneMenuPrice(menuPriceID) {
    return requestGet(`${apiPath.MENU_PRICE.path}/${menuPriceID}`)
  },

  GetAllMenuPrice(paging, sorting, filtering) {
    return requestGet(apiPath.MENU_PRICE.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_menuItemCode: filtering.menuItemCode,
      f_priceType: filtering.priceType,
      f_price: filtering.price
    })
  },

  UpdateMenuPrice(menuPriceID, payload) {
    return requestPut(`${apiPath.MENU_PRICE.path}/${menuPriceID}`, payload)
  },

  DeleteMenuPrice(menuPriceID) {
    return requestDelete(`${apiPath.MENU_PRICE.path}/${menuPriceID}`)
  }
}

export default api
